import { usarUrl } from "@/composable/UsarUrl/usarUrl"
import { Repositorio, UsarLeitorDeDados } from "./usarLeitorDeDados.modelo"

const { converterQueryStringParaObjeto } = usarUrl()

/**
 * @description Classe que implementa um leitor de dados com paginação.
 *
 * @example const leitor = reactive(new UsarLeitorDeDadosPaginados<R, P, C>(repositorio, parametros, cabecalhos))
 *
 * @param R Tipo dos dados retornados pelo repositório
 * @param P Tipo dos parâmetros passados para o repositório
 * @param C Tipo dos cabeçalhos passados para o repositório
 *
 * @extends UsarLeitorDeDados
 */
export class UsarLeitorDeDadosPaginados<R, P = any, C = any> extends UsarLeitorDeDados<R, P, C> {
  paginaAtual: number
  primeiraPagina: number

  constructor(repositorio: Repositorio<R, P, C>, parametros?: P, cabecalhos?: C) {
    super(repositorio, parametros, cabecalhos)
    this.paginaAtual = 0
    this.primeiraPagina = 0
  }

  pagina(pagina: number): this {
    this.paginaAtual = pagina
    this.mudarPaginaNosParametros(pagina.toString())
    return this
  }

  definirPagina(): number {
    return this.paginaAtual * this.itensPorPagina
  }

  async anterior(): Promise<this> {
    const parametrosComoObjeto = converterQueryStringParaObjeto(this.consultaPaginaAnterior)
    this.sobrescreverParametros(parametrosComoObjeto as P)
    await this.executar()

    return this
  }

  async proximo(): Promise<this> {
    const parametrosComoObjeto = converterQueryStringParaObjeto(this.consultaProximaPagina)
    this.sobrescreverParametros(parametrosComoObjeto as P)
    await this.executar()

    return this
  }

  mudarPaginaNosParametros(novaPagina: string): void {
    this.parametrosBase.pagina = novaPagina
  }
}
